import Delegate from '@/types/delegate';
import { ApiAction, Action, AsyncResult } from '../index';
import api from '../redux-api';

// Types
import { DelegateState } from './types/delegate';
import Locale from '@/types/locale';

const INITIAL_STATE: DelegateState = {
  delegates: [],
};

// Actions

const SET_SELECTED_DELEGATE_ACCESS: ApiAction = {
  type: 'connect/delegates/set-selected-delegate-access',
  endpoint: 'delegates/select-access/:id/',
};

const GET_MY_DELEGATES: ApiAction = {
  type: 'connect/delegates/get',
  endpoint: 'delegates/',
};

const REMOVE_DELEGATE: ApiAction = {
  type: 'connect/delegates/remove',
  endpoint: 'delegates/remove/:id/',
};

const ADD_DELEGATE: ApiAction = {
  type: 'connect/delegates/add',
  endpoint: 'delegates/',
};

const VALIDATE_DELEGATE_ACCESS_TOKEN: ApiAction = {
  type: 'connect/delegates/validate-token',
  endpoint: 'delegates/validate-token/:token/',
};

// Action types
export const SELECT_DELEGATE_SUCCESS = `${SET_SELECTED_DELEGATE_ACCESS.type}_SUCCESS`;

// Reducers

export default function reducer(state: DelegateState = INITIAL_STATE, action: Action): DelegateState {
  switch (action.type) {
    case `${GET_MY_DELEGATES.type}_SUCCESS`:
    case `${REMOVE_DELEGATE.type}_SUCCESS`:
    case `${ADD_DELEGATE.type}_SUCCESS`: {
      return {
        ...state,
        delegates: action.data.data,
      };
    }
    default: {
      return state;
    }
  }
}

// Action creators

export const getMyDelegates = (): AsyncResult<Array<Delegate>> => () => api.get(GET_MY_DELEGATES).then((res: { data: any }) => res.data);

export const removeDelegate =
  (id: string): AsyncResult<Array<Delegate>> =>
  () =>
    api.delete(REMOVE_DELEGATE, { id }).then((res: { data: any }) => res.data);

export const addDelegate =
  (email: string, fname: string, lname: string, locale: Locale): AsyncResult<Array<Delegate>> =>
  () => {
    const obj = {
      email,
      fname,
      lname,
      locale,
    };
    return api.post(ADD_DELEGATE, {}, obj).then((res: { data: any }) => res.data);
  };

export const setSelectedDelegateAccess =
  (id: string): AsyncResult<void> =>
  () =>
    api.get(SET_SELECTED_DELEGATE_ACCESS, { id }).then((res: { data: any }) => res.data);

export const validateDelegateAccessToken =
  (token: string): AsyncResult<string> =>
  () =>
    api.get(VALIDATE_DELEGATE_ACCESS_TOKEN, { token }).then((res: { data: any }) => res.data);
